import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ObjectivesPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Objectives</b>
        </h2>
      }
      text_content={
        <div>
          <br />{" "}
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              The primary objective of the study is to assess the bio energy
              status in Uttara Kannada district across the agroclimatic zones.
              This includes:
            </p>
            <ol>
              <li>
                <p>
                  Identifying the bioenergy surplus and deficit places in the
                  district;
                </p>
              </li>
              <li>
                <p>Techno-economic analysis of bio energy applications; and</p>
              </li>
              <li>
                <p>The role of bio energy in sustainable development.</p>
              </li>
            </ol>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ObjectivesPage;
